/* eslint-disable */
export enum projectListLocalisationKeys {
  SEARCH = 'SEARCH',
  WHICH_PROJECT_IS_THIS_DATA_FOR = 'WHICH_PROJECT_IS_THIS_DATA_FOR',
  SELECT_MULTIPLE_PROJECTS = 'SELECT_MULTIPLE_PROJECTS',
  PROJECT_TYPE = 'PROJECT_TYPE',
  NEXT = 'NEXT',
  BACK = 'BACK',
  PLEASE_SELECT_PROJECTS = 'PLEASE_SELECT_PROJECT',
  NO_DATA_PROJECT = 'NO_DATA_PROJECT',
  NO_PROJECTS_FOUND = 'NO_PROJECTS_FOUND'
}

export const enProjectListLocalisationMessages = {
  [projectListLocalisationKeys.SEARCH]: `Search`,
  [projectListLocalisationKeys.WHICH_PROJECT_IS_THIS_DATA_FOR]: `Which project is this data for?`,
  [projectListLocalisationKeys.SELECT_MULTIPLE_PROJECTS]: `You can select multiple projects if the data is combined.`,
  [projectListLocalisationKeys.PROJECT_TYPE]: `Project type`,
  [projectListLocalisationKeys.NEXT]: `Next`,
  [projectListLocalisationKeys.BACK]: `Back`,
  [projectListLocalisationKeys.PLEASE_SELECT_PROJECTS]: `You should choose at least one project`,
  [projectListLocalisationKeys.NO_DATA_PROJECT]: `Sorry, no results were found. Please check your search query or project type filter.`,
  [projectListLocalisationKeys.NO_PROJECTS_FOUND]: `Server responded with no projects, you might be not assigned to a customer`
}
